import React from 'react'
import PropTypes from 'prop-types'
import { orderBy } from 'lodash-es'

export const RelatedPartner = ({ partner, conferenceId }) => {
  // console.log(partner)
  // const partnerUrl = getEventLink(
  //   conferenceId,
  //   conferenceLocation,
  //   'partners/' + partner.data.Company_Url_Slug,
  // )
  const partnerLogo = partner.data.Company_Logo_Url
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : ''
  const utmUrl = `${partner.data.Company_Url}?utm_campaign=${conferenceId}&utm_medium=website&utm_source=uxdx&utm_content=${encodeURIComponent(currentPath)}`

  return (
    <div className="mb-4 grid grid-cols-3 border-b border-gray-200">
      <div className="py-4 pr-4">
        {partnerLogo && (
          <img src={partnerLogo} alt={partner.data.Company_Name + ' Logo'} className="object-cover" />
        )}
      </div>
      <a href={utmUrl} className="pb-4 col-span-2" target="_blank" rel="noreferrer">
        <p className="text-lg font-medium truncate text-gray-700">{partner.data.Company_Name}</p>
        <p className="text-sm  line-clamp-2 text-gray-700">{partner.data.Company_Description_Long}</p>
        <p className="text-xs pt-2 text-gray-400 underline text-right">View More &gt;&gt;</p>
      </a>
    </div>
  )
}

RelatedPartner.propTypes = {
  partner: PropTypes.object.isRequired,
  conferenceLocation: PropTypes.string.isRequired,
  conferenceId: PropTypes.string.isRequired,
}

const RelatedPartners = ({ partners, conferenceLocation, conferenceId }) => {
  if (!partners || partners.length === 0) return <></>
  partners = orderBy(partners, ['data.Company_Priority'], ['asc'])

  return (
    <div className="mt-8 pt-8">
      <h3 className="text-2xl text-gray-500 uppercase pb-4">Related Partners</h3>
      {partners &&
        partners.map((relatedPartner) => {
          return (
            <RelatedPartner
              key={relatedPartner.id}
              partner={relatedPartner}
              conferenceId={conferenceId}
              conferenceLocation={conferenceLocation}
            />
          )
        })}
    </div>
  )
}

RelatedPartners.propTypes = {
  partners: PropTypes.array.isRequired,
  conferenceLocation: PropTypes.string.isRequired,
  conferenceId: PropTypes.string.isRequired,
}

export default RelatedPartners
